!function(e,r){"object"==typeof exports&&"object"==typeof module?module.exports=r():"function"==typeof define&&define.amd?define([],r):"object"==typeof exports?exports.storeblocks=r():e.storeblocks=r()}(self,(()=>(()=>{"use strict";var e={279:(e,r,o)=>{o.d(r,{AlertBase:()=>i,Container:()=>a,Description:()=>c,Title:()=>l});const t=require("styled-components");var n=o.n(t);const i=n().div.attrs({className:"alert"})`
  position: relative;
  display: inline-flex;
  align-items: center;
  box-sizing: border-box;
  max-width: 560px;
  min-width: 288px;

  ${({fluid:e})=>e&&t.css`
      width: 100%;
      max-width: 100%;
    `}

  background: var(--color-info-background);

  outline: 3px dashed;
  outline-offset: -3px;
  outline-color: var(--color-info-accent);

  & > i {
    flex-shrink: 0;
    align-self: flex-start;

    margin: 16px;
    font-size: 24px;
    line-height: 24px;
    color: var(--color-info-accent);
  }

  ${({variant:e})=>"error"===e&&t.css`
      background: var(--color-error-background);
      outline-color: var(--color-error-accent);

      & > i {
        color: var(--color-error-accent);
      }
    `}

  ${({variant:e})=>"warning"===e&&t.css`
      background: var(--color-warning-background);
      outline-color: var(--color-warning-accent);

      & > i {
        color: var(--color-warning-accent);
      }
    `}

  ${({variant:e})=>"success"===e&&t.css`
      background: var(--color-success-background);
      outline-color: var(--color-success-accent);

      & > i {
        color: var(--color-success-accent);
      }
    `}
`,a=n().div`
  max-width: 100%;
  align-self: flex-start;
`,l=n().div`
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  margin: 16px 24px 16px 0;
`,c=n().div`
  font-size: 14px;
  line-height: 24px;
  margin: 24px 24px 16px 0;

  & > a {
    color: var(--color-on-background);
    font-size: 14px;
    line-height: 24px;
  }
`}},r={};function o(t){var n=r[t];if(void 0!==n)return n.exports;var i=r[t]={exports:{}};return e[t](i,i.exports,o),i.exports}o.n=e=>{var r=e&&e.__esModule?()=>e.default:()=>e;return o.d(r,{a:r}),r},o.d=(e,r)=>{for(var t in r)o.o(r,t)&&!o.o(e,t)&&Object.defineProperty(e,t,{enumerable:!0,get:r[t]})},o.o=(e,r)=>Object.prototype.hasOwnProperty.call(e,r),o.r=e=>{"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})};var t={};return(()=>{o.r(t),o.d(t,{default:()=>l});const e=require("@storeblocks/icon"),r=require("react");var n=o.n(r),i=o(279);const a={info:"information-filled",success:"check-circle-filled",warning:"warning-filled",error:"error-filled"},l=(0,r.forwardRef)((function(o,t){var{title:l,variant:c="info",role:s,fluid:d=!1,className:f,description:u,children:p}=o,v=function(e,r){var o={};for(var t in e)Object.prototype.hasOwnProperty.call(e,t)&&r.indexOf(t)<0&&(o[t]=e[t]);if(null!=e&&"function"==typeof Object.getOwnPropertySymbols){var n=0;for(t=Object.getOwnPropertySymbols(e);n<t.length;n++)r.indexOf(t[n])<0&&Object.prototype.propertyIsEnumerable.call(e,t[n])&&(o[t[n]]=e[t[n]])}return o}(o,["title","variant","role","fluid","className","description","children"]);const x=(0,r.useMemo)((()=>null==a?void 0:a[c]),[c]),b=(0,r.useId)();return n().createElement(i.AlertBase,Object.assign({fluid:d,variant:c,className:f,ref:t,"aria-labelledby":b},v),n().createElement(e.SystemIcon,{name:x,"aria-hidden":"true"}),n().createElement(i.Container,{role:s,id:b},n().createElement(i.Title,null,l),(u||p)&&n().createElement(i.Description,null,u||p)))}))})(),t})()));
//# sourceMappingURL=index.js.map